var _linearGradient, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamShuffleText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 270.93333 47.625001",
    id: "svg5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2400"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa3b31",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop2396"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00ff00",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop2398"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient2400",
    id: "linearGradient2402",
    x1: 1.0837958,
    y1: 23.948395,
    x2: 270.25024,
    y2: 23.948395,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2098",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#linearGradient2402)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.69829,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    id: "rect2096",
    width: 269.16644,
    height: 45.681458,
    x: 1.0837958,
    y: 1.1076665,
    ry: 10.265189
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer7",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f2f2f7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.65235,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    id: "rect14769",
    width: 267.103,
    height: 43.577961,
    x: 2.1155188,
    y: 2.1594148,
    ry: 9.7925072
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14738",
    transform: "matrix(0.89935214,0,0,0.89935214,14.682192,2.7065222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1080",
    transform: "matrix(0.37395092,0,0,0.37395092,65.541906,-30.570506)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 143.89817,164.63396 c 0.74084,4.86832 -3.45259,6.04312 -2.39426,8.58311 2.22249,6.03248 3.61959,9.95362 8.91124,12.91695 5.71499,3.28082 14.60496,5.18581 23.60076,5.18581 12.38246,0 21.69577,-3.06915 27.83408,-8.9958 4.86832,-4.76249 7.40831,-11.5358 7.40831,-19.47327 0,-9.73664 -3.80999,-16.82745 -11.42996,-21.58994 -4.02166,-2.53999 -9.10164,-4.33915 -17.14495,-6.03248 -12.48829,-2.53999 -12.48829,-2.53999 -14.60495,-3.49249 -3.38666,-1.58749 -4.97415,-3.80998 -4.97415,-6.77331 0,-4.86832 4.76248,-8.36081 11.2183,-8.36081 8.0433,0 11.85329,2.8575 13.12329,9.73664 l 18.11999,-4.75848 c -1.37583,-6.03248 1.67078,-6.88315 -0.97505,-10.37564 -5.71498,-7.93747 -15.98078,-12.06496 -29.42157,-12.06496 -20.8491,0 -33.97239,10.2658 -33.97239,26.56408 0,8.57248 3.59832,15.66329 10.2658,20.31994 3.91582,2.75166 7.30247,4.02165 17.03911,6.13831 11.00663,2.53999 13.65246,3.28083 15.87495,4.33916 2.75166,1.26999 4.44499,4.12748 4.44499,7.40831 0,5.92664 -4.86832,9.52497 -13.01746,9.52497 -5.39749,0 -9.84247,-1.79917 -12.38246,-4.97416 -1.5875,-2.11666 -2.32833,-4.02165 -2.75166,-7.83164 z",
    id: "path22699",
    style: {
      lineHeight: 1.25,
      fill: "#00ff00",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 6.66667,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    id: "path22098",
    d: "M 205.99695,230.85865 25.371696,221.4892 123.79851,69.747865 Z",
    transform: "matrix(0.19217465,-0.18942635,0.09565653,0.09704436,109.66408,174.97868)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 6.66667,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    id: "path23251",
    d: "M 205.99695,230.85865 25.371696,221.4892 123.79851,69.747865 Z",
    transform: "matrix(-0.22410648,0.15029881,-0.07589791,-0.1131693,234.57742,122.8335)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "aria-label": "eam",
    id: "text6570"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 49.76884,31.621456 c -0.03473,-0.347328 -0.03473,-0.555724 -0.03473,-0.694656 -0.104199,-1.979769 -0.24313,-3.438547 -0.520992,-4.549996 -1.215648,-5.175187 -5.001523,-8.127475 -10.41984,-8.127475 -6.633965,0 -11.04503,4.549996 -11.04503,11.427091 0,3.438547 1.111449,6.390835 3.160684,8.474803 1.97977,1.979769 4.654196,2.952288 8.05801,2.952288 3.438547,0 6.217171,-1.007251 8.196941,-2.952288 0.972518,-0.972519 1.49351,-1.771373 2.292364,-3.577479 l -6.043507,-1.701907 c -0.277862,0.903053 -0.520992,1.285114 -1.041984,1.771373 -0.903052,0.833587 -2.1187,1.285114 -3.508012,1.285114 -2.743892,0 -4.376333,-1.493511 -4.723661,-4.306868 z M 34.243278,26.82833 c 0.590458,-2.292365 2.083968,-3.403814 4.549997,-3.403814 2.396563,0 3.890074,1.180915 4.376333,3.403814 z",
    id: "path1135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.475306,26.550468 c -2.500761,0.06947 -3.542745,0.104198 -4.897324,0.243129 -3.125952,0.277863 -5.45305,1.007252 -7.224423,2.257632 -1.667174,1.146183 -2.535494,2.882823 -2.535494,5.070989 0,1.910304 0.659923,3.577478 1.910304,4.723661 1.389312,1.285113 3.369082,1.910304 6.008774,1.910304 2.84809,0 4.793127,-0.590458 6.738163,-2.083968 v 1.597709 H 73.21347 C 73.039806,38.706948 72.97034,37.456567 72.97034,35.337866 V 25.96001 c 0,-3.125952 -0.972518,-5.036256 -3.195418,-6.251904 -1.354579,-0.729389 -3.85534,-1.215648 -6.425568,-1.215648 -3.369081,0 -5.939308,0.659923 -7.814879,1.97977 -1.458778,1.041984 -2.2229,2.153433 -2.917556,4.202669 l 6.633965,1.076716 c 0.520992,-1.701907 1.701907,-2.431296 3.924806,-2.431296 2.292365,0 3.299616,0.764122 3.299616,2.431296 z m 0,5.418316 c 0,1.041984 -0.451526,1.97977 -1.25038,2.674426 -0.937786,0.798854 -2.500762,1.319846 -3.924807,1.319846 -1.806105,0 -2.848089,-0.729388 -2.848089,-1.979769 0,-1.007251 0.764121,-1.875571 2.014502,-2.292365 1.424045,-0.451526 2.917555,-0.62519 6.008774,-0.694656 z",
    id: "path1137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 84.050044,40.269924 c -0.208397,-1.701908 -0.277863,-3.056487 -0.277863,-5.244653 v -7.016026 c 0.972519,-2.36183 2.570228,-3.716409 4.445799,-3.716409 0.833587,0 1.528243,0.312595 1.910304,0.86832 0.451526,0.590457 0.590457,1.250381 0.590457,2.709158 v 7.154957 c 0,2.222899 -0.06946,3.681677 -0.277862,5.244653 h 7.224422 c -0.208396,-1.667175 -0.277862,-3.125952 -0.277862,-5.20992 v -7.085491 c 0.86832,-2.327098 2.466029,-3.71641 4.237401,-3.71641 1.97977,0 2.74389,1.007251 2.74389,3.612211 v 7.154957 c 0,2.36183 -0.0695,3.612211 -0.27786,5.244653 h 7.22442 c -0.2084,-1.632442 -0.27786,-3.056487 -0.27786,-5.20992 v -8.613735 c 0,-5.244652 -2.5355,-7.953811 -7.50229,-7.953811 -3.02175,0 -5.14045,0.903053 -7.293883,3.021754 -0.451527,-0.86832 -0.798855,-1.285114 -1.424045,-1.73664 -1.146183,-0.833587 -2.639693,-1.250381 -4.445799,-1.250381 -2.743891,0 -4.862592,0.903053 -6.633964,2.84809 0,-0.06947 0,-0.138932 0,-0.173664 0,-0.104199 0,-0.173664 0,-0.173664 0.03473,-0.347328 0.03473,-0.347328 0.03473,-0.48626 v -1.458777 h -6.877094 c 0.208397,1.354579 0.277863,2.60496 0.277863,5.244653 v 10.697702 c 0,2.188166 -0.06947,3.646944 -0.277863,5.244653 z",
    id: "path1139"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "aria-label": "huffle",
    id: "text12241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 153.16731,40.269924 c -0.2084,-1.806106 -0.27786,-3.264884 -0.27786,-5.244653 v -7.050758 c 1.38931,-2.292365 3.26488,-3.612212 5.24465,-3.612212 0.97252,0 1.73664,0.312596 2.2229,0.937786 0.41679,0.590458 0.55572,1.215648 0.55572,2.60496 v 7.120224 c 0,2.118701 -0.0695,3.577478 -0.27786,5.244653 h 7.22442 c -0.17366,-1.458778 -0.27786,-3.195418 -0.27786,-5.20992 v -8.717933 c 0,-2.743891 -0.59046,-4.445798 -1.97977,-5.83511 -1.28511,-1.285114 -3.16068,-1.945037 -5.52252,-1.945037 -2.95228,0 -5.14045,0.86832 -7.22442,2.882822 0,-0.312595 0.0347,-0.86832 0.0347,-1.146182 v -3.681677 c 0,-2.466029 0.0695,-3.716409 0.27786,-5.244653 h -7.18969 c 0.20839,1.35458 0.27786,2.84809 0.27786,5.244653 v 18.408384 c 0,2.153433 -0.0695,3.612211 -0.27786,5.244653 z",
    id: "path1058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 186.12871,19.082916 c 0.2084,1.806105 0.27786,3.264883 0.27786,5.20992 v 7.120224 c -1.35458,2.222899 -3.29962,3.577478 -5.20992,3.577478 -1.00725,0 -1.77137,-0.347328 -2.25763,-0.972518 -0.41679,-0.555725 -0.55573,-1.180916 -0.55573,-2.60496 v -7.120224 c 0,-2.083968 0.0695,-3.542746 0.27787,-5.20992 h -7.22443 c 0.17367,1.458777 0.27787,3.195417 0.27787,5.20992 v 8.717932 c 0,2.743892 0.59045,4.445799 1.97977,5.835111 1.31984,1.285113 3.19541,1.945037 5.52251,1.945037 2.95229,0 4.93206,-0.833588 7.22442,-2.987021 -0.0347,0.243129 -0.0347,0.764121 -0.0347,0.937785 v 1.493511 h 6.91183 c -0.2084,-1.389312 -0.27786,-2.813357 -0.27786,-5.20992 V 24.292836 c 0,-2.118701 0.0695,-3.577479 0.27786,-5.20992 z",
    id: "path1060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200.2302,24.431767 v 10.593504 c 0,2.257632 -0.0695,3.542745 -0.27786,5.244653 h 7.22442 c -0.2084,-1.701908 -0.27786,-2.84809 -0.27786,-5.244653 V 24.431767 h 1.07671 c 1.94504,0 3.09122,0.06947 4.55,0.24313 v -5.835111 c -1.28511,0.138931 -3.16068,0.24313 -4.61946,0.24313 h -1.00725 v -0.86832 c 0,-1.806106 0.65992,-2.500762 2.36183,-2.500762 1.31984,0 2.36183,0.277863 3.43854,0.86832 l 1.07672,-5.105721 c -1.9103,-0.520992 -3.33435,-0.729389 -5.27938,-0.729389 -5.66145,0 -8.26641,2.118701 -8.26641,6.70343 v 1.632442 h -0.93779 c -1.31984,0 -2.91755,-0.104199 -3.89007,-0.24313 v 5.835111 c 1.18091,-0.173664 2.25763,-0.24313 3.89007,-0.24313 z",
    id: "path1062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 219.1248,24.431767 v 10.593504 c 0,2.257632 -0.0695,3.542745 -0.27787,5.244653 h 7.22442 c -0.20839,-1.701908 -0.27786,-2.84809 -0.27786,-5.244653 V 24.431767 h 1.07672 c 1.94504,0 3.09122,0.06947 4.55,0.24313 v -5.835111 c -1.28512,0.138931 -3.16069,0.24313 -4.61947,0.24313 h -1.00725 v -0.86832 c 0,-1.806106 0.65993,-2.500762 2.36183,-2.500762 1.31985,0 2.36183,0.277863 3.43855,0.86832 l 1.07672,-5.105721 c -1.91031,-0.520992 -3.33435,-0.729389 -5.27939,-0.729389 -5.66145,0 -8.2664,2.118701 -8.2664,6.70343 v 1.632442 h -0.93779 c -1.31985,0 -2.91756,-0.104199 -3.89007,-0.24313 v 5.835111 c 1.18091,-0.173664 2.25763,-0.24313 3.89007,-0.24313 z m 14.6225,-13.059533 c 0.2084,1.319847 0.27787,2.778624 0.27787,5.244653 v 18.408384 c 0,2.500761 -0.0695,3.681677 -0.27787,5.244653 h 7.25916 c -0.2084,-1.840839 -0.27786,-3.160685 -0.27786,-5.244653 V 16.616887 c 0,-2.36183 0.0695,-3.785875 0.27786,-5.244653 z",
    id: "path1064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 265.7709,31.621456 c -0.0347,-0.347328 -0.0347,-0.555724 -0.0347,-0.694656 -0.1042,-1.979769 -0.24313,-3.438547 -0.52099,-4.549996 -1.21565,-5.175187 -5.00152,-8.127475 -10.41984,-8.127475 -6.63396,0 -11.04503,4.549996 -11.04503,11.427091 0,3.438547 1.11145,6.390835 3.16069,8.474803 1.97977,1.979769 4.65419,2.952288 8.05801,2.952288 3.43854,0 6.21717,-1.007251 8.19694,-2.952288 0.97251,-0.972519 1.49351,-1.771373 2.29236,-3.577479 l -6.04351,-1.701907 c -0.27786,0.903053 -0.52099,1.285114 -1.04198,1.771373 -0.90305,0.833587 -2.1187,1.285114 -3.50801,1.285114 -2.74389,0 -4.37634,-1.493511 -4.72366,-4.306868 z M 250.24533,26.82833 c 0.59046,-2.292365 2.08397,-3.403814 4.55,-3.403814 2.39656,0 3.89007,1.180915 4.37633,3.403814 z",
    id: "path1066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1072",
    transform: "matrix(0.39382049,0,0,0.39382049,-26.9847,-25.11797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 126.93794,98.830813 h 11.95913 c 7.61998,0 11.74747,0.211666 16.50995,0.740831 V 79.357541 c -4.86832,0.529165 -9.10164,0.740831 -16.50995,0.740831 H 92.54222 c -6.455813,0 -12.276628,-0.317499 -15.769117,-0.740831 v 20.214103 c 7.514143,-0.634998 9.313304,-0.740831 15.980783,-0.740831 h 12.488294 v 53.339837 c 0,6.66747 -0.21167,11.00663 -0.84666,15.98078 h 23.38909 c -0.635,-4.97415 -0.84667,-9.6308 -0.84667,-15.98078 z",
    style: {
      fill: "#fa3b31",
      strokeWidth: 0.264583
    },
    id: "path1176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect23606",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.76389,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    d: "m 79.277168,79.62481 2.487796,0.163592 -0.01642,19.388909 -2.491219,0.192911 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 105.27347,79.910368 10.83368,18.405684 10.80133,-18.392398 z",
    id: "path24269"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect25093",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.76389,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    d: "m 150.40835,79.779985 2.51602,-0.17343 -0.0133,19.730632 -2.50268,-0.193441 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect25290",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.9138,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    transform: "rotate(90)",
    d: "m 163.15942,-127.29913 2.49601,-0.19432 v 22.80678 l -2.49601,-0.19432 z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamShuffleText);
export default __webpack_public_path__ + "static/media/team-shuffle-text.087722b3bdaca5c4bdc49a597c0db10f.svg";
export { ForwardRef as ReactComponent };